module.exports = __webpack_public_path__ + "static/media/car4.52630955.svg";